import { Component, Input, SimpleChanges } from '@angular/core';

export interface InvoiceSalesRow {
  id: number;
  date?: string | Date;

  series: string;
  number: string;
  nit: string;
  client: string;

  quantity: number;
  price: number;
  taxes: number;
  amount: number;

  code: string;
  productName: string;

  destination: string;
  place: string;

  cost: number;
  margin: number;
  paymentMethod: string;

}

@Component({
  selector: 'app-general-table-preview',
  templateUrl: './general-table-preview.component.html',
  styleUrls: ['./general-table-preview.component.scss']
})
export class GeneralTablePreviewComponent {
  @Input() data: InvoiceSalesRow[] | null = null;
  @Input() loading = false;

  trackById = (_: number, item: InvoiceSalesRow) =>
    item.id;

  nz(v: number | null | undefined): number {
    return v ?? 0;
  }
}
